import React from "react";
import { createRoot } from "react-dom/client";
import "../../css/partner_dashboard.css";
import UserPasswordReset from "../../components/password_reset/user_password_reset";

function init() {
  const rootElement = document.getElementById("password-reset-set-user-password-root");

  if (!rootElement) return;
  const root = createRoot(rootElement);
  const actionKey = rootElement?.dataset.actionKey || "";
  const schoolLogo = rootElement?.dataset.schoolLogo || "";
  const schoolName = rootElement?.dataset.schoolName || "";
  const baseUrl = rootElement?.dataset.baseUrl || "";
  const linkExpired = rootElement?.dataset.linkExpired === "true" || false;

  if (rootElement) {
    root.render(
      <UserPasswordReset
        actionKey={actionKey}
        linkExpired={linkExpired}
        baseUrl={baseUrl}
        schoolLogo={schoolLogo}
        schoolName={schoolName}
      />,
    );
  }
}
if (document.readyState === "complete" || document.readyState === "interactive") {
  // document has at least been parsed
  init();
} else {
  document.addEventListener("DOMContentLoaded", () => {
    init();
  });
}
